import { alpha, Theme } from '@mui/material/styles';
import { glassPrintSurface, glassSurface } from '../glass';

// ----------------------------------------------------------------------

export default function Dialog(theme: Theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {  
          ...glassSurface(theme, 'strong'),
          opacity: 1,
          boxShadow: theme.customShadows.dialog,
          '&.MuiPaper-rounded': {
            borderRadius: Number(theme.shape.borderRadius) * 2,
          },
          '&.MuiDialog-paperFullScreen': {
            borderRadius: 0,
            backgroundColor: theme.palette.background.default,
            backdropFilter: 'none',
            WebkitBackdropFilter: 'none',
            '@media print': {
              ...glassPrintSurface(theme),
            },
          },
          '&.MuiDialog-paper .MuiDialogActions-root': {
            padding: theme.spacing(3),
          },
          '@media (max-width: 600px)': {
            margin: theme.spacing(2),
          },
          '@media (max-width: 663.95px)': {
            '&.MuiDialog-paperWidthSm.MuiDialog-paperScrollBody': {
              maxWidth: '100%',
            },
          },
        },
        paperFullWidth: {
          width: '100%',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),        
          backgroundColor: alpha(theme.palette.background.neutral, theme.palette.mode === 'light' ? 0.18 : 0.14),
          color: theme.palette.text.secondary,
          borderBottom: `solid 1px ${theme.palette.divider}`,
          '@media print': {
            ...glassPrintSurface(theme),
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0, 3),
        },
        dividers: {
          borderTop: 0,
          borderBottomStyle: 'dashed',
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(3),
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          '& > :not(:first-of-type)': {
            marginLeft: theme.spacing(1.5),
          },
        },
      },
    },
  };
}
